module.exports = __webpack_public_path__ + "img/FL.94fc34b9.png";